import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useStore } from "vuex";
import ReservationForm from "@/components/shared/ReservationForm.vue";
import { useI18n } from "vue-i18n";
import { useToast } from "primevue/usetoast";
import { useRouter } from "vue-router";
import { onMounted, ref } from "vue";
import { dateToISO, DateTimeToISOString } from "@/assets/utils/date";
import { useNotify } from "@/composables/useNotify";

export default /*#__PURE__*/_defineComponent({
  __name: 'edit',
  setup(__props) {

const router = useRouter();

const store = useStore();
const { t } = useI18n();

const { successToast, errorToast } = useNotify({ t });
const updateReservation = async ({ reservation, notifyClient }) => {
  try {
    await store.dispatch("reservation/CHANGE_RESERVATION_DETAILS", {
      reservation,
      notifyClient,
    });
    successToast({ title: t("reservation"), detail: t("updatedSuccessfully") });

    const startDate = DateTimeToISOString(new Date(reservation.at));
    router.push({ name: "ReservationList", query: { startDate } });
  } catch (e: any | Error) {
    errorToast({ title: t("reservation"), error: e?.message });
  }
};
const reservationToUpdate = ref<any>(null);
onMounted(async () => {
  const id = router.currentRoute.value.params.id;
  const reservation = await store.dispatch("reservation/RETRIEVE_BY_ID", {
    id,
  });
  reservation.at = dateToISO({ date: reservation.at });
  reservationToUpdate.value = reservation;
});

return (_ctx: any,_cache: any) => {
  return (reservationToUpdate.value)
    ? (_openBlock(), _createBlock(ReservationForm, {
        key: 0,
        "is-update": "",
        "reservation-data": reservationToUpdate.value,
        onSave: updateReservation
      }, null, 8, ["reservation-data"]))
    : _createCommentVNode("", true)
}
}

})